export default __webpack_public_path__ + "static/media/mp3_icon.98fcbfb5.png";